import { useState } from "react";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { VenueForm } from "@/components/forms/CampaignFormSections/VenueForm";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { VenueFormValues } from "@/components/forms/CampaignFormSections/VenueForm/types";

export default function AddVenue() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  
  const handleSubmit = async (values: VenueFormValues) => {
    try {
      setIsSubmitting(true);
      
      // Ensure name is not undefined before submitting to Supabase
      if (!values.name) {
        throw new Error("Venue name is required");
      }
      
      // Create a new object with name explicitly set to ensure TypeScript knows it's non-optional
      const venueData = {
        name: values.name,
        address: values.address,
        city: values.city,
        state: values.state,
        zip: values.zip,
        phone: values.phone,
        website: values.website,
        hours: values.hours,
        latitude: values.latitude,
        longitude: values.longitude,
        maps_link: values.maps_link
      };
      
      const { data, error } = await supabase
        .from('venues')
        .insert(venueData)
        .select()
        .single();
        
      if (error) throw error;
      
      toast.success("Venue added successfully");
      navigate("/admin/venues");
    } catch (error) {
      console.error("Error adding venue:", error);
      toast.error("Failed to add venue");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <AdminLayout
      title="Add Venue"
      subtitle="Add a new venue for voucher redemption"
    >
      <VenueForm 
        onSubmit={handleSubmit} 
        onCancel={() => navigate("/admin/venues")}
      />
    </AdminLayout>
  );
}
